import { translate, forecastRoutes, alertRoutes, newsRoutes, lifeRoutes, storyLegacyRoutes, aqiRoute, hurricaneRoute } from '../../../common/translation/translate';
import { NewsStoryPopupSourceRoutes } from './newsStoryPopupTypes';

export const getPageSpecificPopupData = (sourceRoute: string) => {
    let popupData;
    switch (sourceRoute) {
        case storyLegacyRoutes.lifePollenStory:
        case NewsStoryPopupSourceRoutes.LifePollenPage:
            popupData = { 
                sourceRoute: lifeRoutes.lifePollen, 
                sourceRouteName: translate('pollen')
            };
            break;
        case storyLegacyRoutes.lifeColdFluStory:
        case NewsStoryPopupSourceRoutes.LifeColdFluPage:
            popupData = { 
                sourceRoute: lifeRoutes.lifeColdFlu, 
                sourceRouteName: translate('coldFlu')
            };
            break;
        case NewsStoryPopupSourceRoutes.LifeOutdoorSportsPage:
            popupData = { 
                sourceRoute: lifeRoutes.lifeOutdoorSports, 
                sourceRouteName: translate('outdoorSports')
            };
            break;
        case NewsStoryPopupSourceRoutes.NewsPage:
            popupData = { 
                sourceRoute: newsRoutes.news, 
                sourceRouteName: translate('news')
            };
            break;
        case NewsStoryPopupSourceRoutes.AllAlerts:
            popupData = {
                sourceRoute: alertRoutes.allAlerts, 
                sourceRouteName: translate('allAlerts')
            };
            break;
        case NewsStoryPopupSourceRoutes.SparkAlerts:
            popupData = {
                sourceRoute: alertRoutes.sparkAlerts, 
                sourceRouteName: translate('spark')
            };
            break;
        case NewsStoryPopupSourceRoutes.WeatherAlerts:
            popupData = {
                sourceRoute: alertRoutes.weatherAlerts, 
                sourceRouteName: `${translate('weatherAlerts')} ${translate('alerts')}`
            };
            break;
        case NewsStoryPopupSourceRoutes.HurricaneAlerts:
        case storyLegacyRoutes.hurricaneStory:
            popupData = {
                sourceRoute: alertRoutes.hurricaneAlerts, 
                sourceRouteName: translate('hurricaneAlerts')
            };
            break;
        case NewsStoryPopupSourceRoutes.PollenAlerts:
            popupData = {
                sourceRoute: alertRoutes.weatherAlerts, 
                sourceRouteName: `${translate('pollenAlerts')} ${translate('alerts')}`
            };
            break;
        case NewsStoryPopupSourceRoutes.AirQualityAlerts:
            popupData = {
                sourceRoute: alertRoutes.weatherAlerts, 
                sourceRouteName: `${translate('airQualityAlerts')} ${translate('alerts')}`
            };
            break;
        case NewsStoryPopupSourceRoutes.SeverStormRisksAlerts:
            popupData = { 
                sourceRoute: alertRoutes.weatherAlerts, 
                sourceRouteName: `${translate('severeStormRiskAlerts')} ${translate('alerts')}`
            };
            break;
        case NewsStoryPopupSourceRoutes.FireAlerts:
            popupData = {
                sourceRoute: alertRoutes.fireAlerts, 
                sourceRouteName: translate('fireAlerts')
            };
            break;
        case NewsStoryPopupSourceRoutes.AirQualityPage:
            popupData = {  
                sourceRoute: aqiRoute.airquality, 
                sourceRouteName: translate('airquality')
            };
            break;
        case NewsStoryPopupSourceRoutes.HurricanePage:
            popupData = {  
                sourceRoute: hurricaneRoute.hurricane, 
                sourceRouteName: translate('hurricane')
            };
            break;
        default:
            popupData = { 
                sourceRoute: forecastRoutes.now, 
                sourceRouteName: translate('forecasts')
            };
    }
    return popupData;
};
